// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Chip from "../components/Chip/Chip.bs.js";
import * as Alert from "../components/Alert/Alert.bs.js";
import * as Input from "../components/Input/Input.bs.js";
import * as Theme from "../styles/Theme.bs.js";
import * as React from "react";
import * as Button from "../components/Button/Button.bs.js";
import * as Emotion from "../bindings/Emotion.bs.js";
import * as Excerpt from "../lib/Excerpt.bs.js";
import * as Skeleton from "../components/Skeleton/Skeleton.bs.js";
import * as Textarea from "../components/Textarea/Textarea.bs.js";
import * as FormField from "../components/FormField/FormField.bs.js";
import * as DateFormat from "../lib/DateFormat.bs.js";
import * as IconButton from "../components/IconButton/IconButton.bs.js";
import * as Typography from "../components/Typography/Typography.bs.js";
import * as ArticleMeta from "../components/ArticleMeta/ArticleMeta.bs.js";
import * as RescriptRelay from "rescript-relay/src/RescriptRelay.bs.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as RescriptRelay_Query from "rescript-relay/src/RescriptRelay_Query.bs.js";
import * as RescriptRelay_Mutation from "rescript-relay/src/RescriptRelay_Mutation.bs.js";
import * as JournalPageQuery_graphql from "../__generated__/JournalPageQuery_graphql.bs.js";
import * as RescriptReactErrorBoundary from "@rescript/react/src/RescriptReactErrorBoundary.bs.js";
import * as JournalPageCreatePostMutation_graphql from "../__generated__/JournalPageCreatePostMutation_graphql.bs.js";
import * as JournalPageUpdatePostMutation_graphql from "../__generated__/JournalPageUpdatePostMutation_graphql.bs.js";

let convertVariables = JournalPageQuery_graphql.Internal.convertVariables;

let convertResponse = JournalPageQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = JournalPageQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, JournalPageQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, JournalPageQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(JournalPageQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(JournalPageQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(JournalPageQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(JournalPageQuery_graphql.node, convertVariables);

let PostsQuery = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

let convertVariables$1 = JournalPageCreatePostMutation_graphql.Internal.convertVariables;

let convertResponse$1 = JournalPageCreatePostMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = JournalPageCreatePostMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables$1, JournalPageCreatePostMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, JournalPageCreatePostMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let CreatePostMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation,
  use: use$1
};

let convertVariables$2 = JournalPageUpdatePostMutation_graphql.Internal.convertVariables;

let convertResponse$2 = JournalPageUpdatePostMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$2 = JournalPageUpdatePostMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$2, JournalPageUpdatePostMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables$2, JournalPageUpdatePostMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

let UpdatePostMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$2,
  convertResponse: convertResponse$2,
  convertWrapRawResponse: convertWrapRawResponse$2,
  commitMutation: commitMutation$1,
  use: use$2
};

let inputValue = (function(evt) { return evt.target.value });

function prependCreatedPost(store, _response) {
  let created = store.getRootField("createPost");
  if (created == null) {
    return;
  }
  let root = store.getRoot();
  let existing = Stdlib_Option.getOr(RescriptRelay.RecordProxy.getLinkedRecords(root, "posts", undefined), []);
  root.setLinkedRecords([Primitive_option.some(created)].concat(existing), "posts");
}

function JournalPage$Desk(props) {
  let url = RescriptReactRouter.useUrl(undefined, undefined);
  let data = use(undefined, undefined, undefined, undefined);
  let match = use$1();
  let createPost = match[0];
  let match$1 = use$2();
  let updatePost = match$1[0];
  let match$2 = url.path;
  let selection;
  let exit = 0;
  if (match$2 !== 0 && match$2.hd === "journal") {
    let match$3 = match$2.tl;
    if (match$3 !== 0) {
      let id = match$3.hd;
      if (id === "new") {
        if (match$3.tl !== 0) {
          exit = 1;
        } else {
          selection = "NewEntry";
        }
      } else if (match$3.tl !== 0) {
        exit = 1;
      } else {
        selection = {
          TAG: "Existing",
          _0: id
        };
      }
    } else {
      exit = 1;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    let post = data.posts[0];
    selection = post !== undefined ? ({
        TAG: "Existing",
        _0: post.id
      }) : "NewEntry";
  }
  let selectedPost;
  if (typeof selection !== "object") {
    selectedPost = undefined;
  } else {
    let id$1 = selection._0;
    selectedPost = data.posts.find(post => post.id === id$1);
  }
  let match$4 = React.useState(() => "");
  let setTitle = match$4[1];
  let title = match$4[0];
  let match$5 = React.useState(() => "");
  let setBody = match$5[1];
  let body = match$5[0];
  let match$6 = React.useState(() => "Quiet");
  let setNotice = match$6[1];
  let selectionKey;
  selectionKey = typeof selection !== "object" ? "new" : selection._0;
  React.useEffect(() => {
    if (typeof selection !== "object") {
      setTitle(param => "");
      setBody(param => "");
      setNotice(param => "Quiet");
    } else if (selectedPost !== undefined) {
      setTitle(param => selectedPost.title);
      setBody(param => selectedPost.body);
      setNotice(param => "Quiet");
    }
  }, [selectionKey]);
  let saving = match[1] || match$1[1];
  let handleSave = _evt => {
    let nextTitle = title.trim();
    let nextBody = body.trim();
    if (nextTitle === "" || nextBody === "") {
      return setNotice(param => "EmptyFields");
    }
    if (typeof selection !== "object") {
      createPost({
        body: nextBody,
        title: nextTitle
      }, undefined, undefined, prependCreatedPost, (response, _errors) => {
        setNotice(param => "Saved");
        RescriptReactRouter.push("/journal/" + response.createPost.id);
      }, param => setNotice(param => "SaveFailed"), undefined);
      return;
    }
    updatePost({
      body: nextBody,
      id: selection._0,
      title: nextTitle
    }, undefined, undefined, undefined, (_response, _errors) => setNotice(param => "Saved"), param => setNotice(param => "SaveFailed"), undefined);
  };
  let shellStyles = Emotion.Css.css({
    display: "grid",
    gridTemplateColumns: "minmax(240px, 22rem) 1fr",
    minHeight: "calc(100vh - 6.75rem)",
    borderTop: `1px solid ` + Emotion.Utils.Color.border,
    "@media (max-width: 800px)": {
      gridTemplateColumns: "1fr",
      minHeight: "auto"
    }
  });
  let listStyles = Emotion.Css.css({
    borderRight: `1px solid ` + Emotion.Utils.Color.border,
    backgroundColor: Emotion.Utils.Color.bgPrimary,
    display: "flex",
    flexDirection: "column",
    minHeight: "0"
  });
  let listHeaderStyles = Emotion.Css.css({
    padding: "1.5rem 1.5rem 1rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    gap: "1rem",
    borderBottom: `1px solid ` + Emotion.Utils.Color.border
  });
  let cardStyles = active => Emotion.Css.css({
    display: "block",
    padding: "1.25rem 1.5rem",
    borderBottom: `1px solid ` + Emotion.Utils.Color.border,
    textDecoration: "none",
    color: "inherit",
    cursor: "pointer",
    backgroundColor: active ? Emotion.Utils.Color.bgSecondary : "transparent",
    borderLeft: active ? `4px solid ` + Emotion.Utils.Color.primary : "4px solid transparent",
    ":hover": {
      backgroundColor: Emotion.Utils.Color.bgSecondary
    }
  });
  let paneStyles = Emotion.Css.css({
    position: "relative",
    backgroundColor: Emotion.Utils.Color.bgSecondary,
    display: "flex",
    flexDirection: "column",
    minHeight: "0"
  });
  let editorWrapStyles = Emotion.Css.css({
    flex: "1",
    overflowY: "auto",
    padding: "3rem max(1.5rem, 8vw) 8rem"
  });
  let editorStyles = Emotion.Css.css({
    maxWidth: "65ch",
    margin: "0 auto",
    width: "100%"
  });
  let titleInputStyles = Emotion.Css.css({
    fontFamily: Theme.Theme.Typography.fontFamily.serif,
    fontSize: "clamp(2rem, 4vw, 3rem)",
    fontWeight: "400",
    lineHeight: "1.15",
    letterSpacing: "-0.02em",
    marginBottom: "1.5rem"
  });
  let toolbarStyles = Emotion.Css.css({
    position: "absolute",
    bottom: "1.5rem",
    left: "0",
    right: "0",
    display: "flex",
    justifyContent: "center",
    pointerEvents: "none"
  });
  let toolbarInnerStyles = Emotion.Css.css({
    pointerEvents: "auto",
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
    padding: "0.5rem 0.75rem",
    borderRadius: Emotion.Utils.Border.getRadius("full"),
    border: `1px solid ` + Emotion.Utils.Color.border,
    backgroundColor: Emotion.Utils.Color.bgPrimary
  });
  let entryCount = data.posts.length.toString();
  let tmp;
  let exit$1 = 0;
  if (typeof selection !== "object" || selectedPost !== undefined) {
    exit$1 = 1;
  } else {
    tmp = JsxRuntime.jsx(Typography.Typography.Body.make, {
      className: Emotion.Css.css({
        color: Emotion.Utils.Color.textSecondary
      }),
      children: "That entry is not in this desk."
    });
  }
  if (exit$1 === 1) {
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(ArticleMeta.ArticleMeta.make, {
          date: selectedPost !== undefined ? DateFormat.formatLong(selectedPost.createdAt) : "Unpublished draft"
        }),
        JsxRuntime.jsx(Chip.Chip.make, {
          className: Emotion.Css.css({
            marginBottom: "1.25rem"
          }),
          children: selection === "NewEntry" ? "#draft" : "#desk"
        }),
        JsxRuntime.jsx(FormField.FormField.make, {
          label: "Title",
          htmlFor: "entry-title",
          hideLabel: true,
          children: JsxRuntime.jsx(Input.Input.make, {
            variant: "editorial",
            placeholder: "Title",
            value: title,
            onChange: evt => {
              let value = inputValue(evt);
              setTitle(param => value);
            },
            className: titleInputStyles,
            ariaLabel: "Entry title",
            id: "entry-title"
          })
        }),
        JsxRuntime.jsx(FormField.FormField.make, {
          label: "Entry",
          htmlFor: "entry-body",
          hideLabel: true,
          children: JsxRuntime.jsx(Textarea.Textarea.make, {
            variant: "editorial",
            placeholder: "Write the entry…",
            value: body,
            onChange: evt => {
              let value = inputValue(evt);
              setBody(param => value);
            },
            ariaLabel: "Entry body",
            id: "entry-body",
            rows: 16
          })
        })
      ]
    });
  }
  let tmp$1;
  switch (match$6[0]) {
    case "Quiet" :
      tmp$1 = null;
      break;
    case "Saved" :
      tmp$1 = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Alert.Alert.make, {
          variant: "success",
          children: "Saved."
        }),
        className: Emotion.Css.css({
          padding: "0 1.5rem 5.5rem"
        })
      });
      break;
    case "EmptyFields" :
      tmp$1 = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Alert.Alert.make, {
          variant: "warning",
          children: "Title and entry both need a little ink."
        }),
        className: Emotion.Css.css({
          padding: "0 1.5rem 5.5rem"
        })
      });
      break;
    case "SaveFailed" :
      tmp$1 = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Alert.Alert.make, {
          variant: "error",
          children: "Could not save this entry."
        }),
        className: Emotion.Css.css({
          padding: "0 1.5rem 5.5rem"
        })
      });
      break;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("section", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Typography.Typography.Heading.make, {
                    level: "h2",
                    size: "lg",
                    children: "Journal"
                  }),
                  JsxRuntime.jsx(Typography.Typography.Caption.make, {
                    children: entryCount + (
                      data.posts.length === 1 ? " entry" : " entries"
                    )
                  })
                ]
              }),
              JsxRuntime.jsx(IconButton.IconButton.make, {
                label: "New entry",
                variant: "ghost",
                size: "sm",
                onClick: param => RescriptReactRouter.push("/journal/new"),
                children: "＋"
              })
            ],
            className: listHeaderStyles
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("a", {
                children: [
                  JsxRuntime.jsx(Typography.Typography.Overline.make, {
                    children: "Draft"
                  }),
                  JsxRuntime.jsx(Typography.Typography.Heading.make, {
                    level: "h3",
                    size: "lg",
                    className: Emotion.Css.css({
                      marginTop: "0.35rem"
                    }),
                    children: "New entry"
                  }),
                  JsxRuntime.jsx(Typography.Typography.Body.make, {
                    className: Emotion.Css.css({
                      color: Emotion.Utils.Color.textSecondary,
                      margin: "0.35rem 0 0"
                    }),
                    children: "Start a blank page in the desk."
                  })
                ],
                className: cardStyles(selection === "NewEntry"),
                href: "/journal/new",
                onClick: evt => {
                  evt.preventDefault();
                  RescriptReactRouter.push("/journal/new");
                }
              }),
              data.posts.map(post => {
                let active;
                active = typeof selection !== "object" ? false : selection._0 === post.id;
                return JsxRuntime.jsxs("a", {
                  children: [
                    JsxRuntime.jsx(Typography.Typography.Overline.make, {
                      children: DateFormat.formatShort(post.createdAt)
                    }),
                    JsxRuntime.jsx(Typography.Typography.Heading.make, {
                      level: "h3",
                      size: "lg",
                      className: Emotion.Css.css({
                        marginTop: "0.35rem"
                      }),
                      children: post.title
                    }),
                    JsxRuntime.jsx(Typography.Typography.Body.make, {
                      className: Emotion.Css.css({
                        color: Emotion.Utils.Color.textSecondary,
                        margin: "0.35rem 0 0"
                      }),
                      children: Excerpt.fromBody(post.body, undefined)
                    })
                  ],
                  className: cardStyles(active),
                  href: "/journal/" + post.id,
                  onClick: evt => {
                    evt.preventDefault();
                    RescriptReactRouter.push("/journal/" + post.id);
                  }
                }, post.id);
              })
            ],
            className: Emotion.Css.css({
              overflowY: "auto",
              flex: "1"
            })
          })
        ],
        className: listStyles
      }),
      JsxRuntime.jsxs("section", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: tmp,
              className: editorStyles
            }),
            className: editorWrapStyles
          }),
          tmp$1,
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(IconButton.IconButton.make, {
                  label: "View posts",
                  variant: "ghost",
                  onClick: param => RescriptReactRouter.push("/posts"),
                  children: "☰"
                }),
                JsxRuntime.jsx(Button.Button.make, {
                  variant: "primary",
                  size: "sm",
                  disabled: saving,
                  onClick: handleSave,
                  children: saving ? "Saving…" : "Save"
                })
              ],
              className: toolbarInnerStyles
            }),
            className: toolbarStyles
          })
        ],
        className: paneStyles
      })
    ],
    className: shellStyles
  });
}

let Desk = {
  inputValue: inputValue,
  prependCreatedPost: prependCreatedPost,
  make: JournalPage$Desk
};

function JournalPage(props) {
  return JsxRuntime.jsx(RescriptReactErrorBoundary.make, {
    children: JsxRuntime.jsx(React.Suspense, {
      children: JsxRuntime.jsx(JournalPage$Desk, {}),
      fallback: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Skeleton.Skeleton.make, {
            variant: "title"
          }),
          JsxRuntime.jsx(Skeleton.Skeleton.Stack.make, {
            count: 4,
            className: Emotion.Css.css({
              marginTop: "1.25rem"
            })
          })
        ],
        className: Emotion.Css.css({
          padding: "4rem 1.5rem",
          maxWidth: "40rem"
        })
      })
    }),
    fallback: param => JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(Typography.Typography.Body.make, {
        className: Emotion.Css.css({
          color: Emotion.Utils.Color.textSecondary
        }),
        children: "The journal desk could not load."
      }),
      className: Emotion.Css.css({
        padding: "4rem 1.5rem"
      })
    })
  });
}

let Typography$1;

let Button$1;

let Alert$1;

let Skeleton$1;

let Input$1;

let Textarea$1;

let FormField$1;

let ArticleMeta$1;

let IconButton$1;

let Chip$1;

let make = JournalPage;

export {
  PostsQuery,
  CreatePostMutation,
  UpdatePostMutation,
  Typography$1 as Typography,
  Button$1 as Button,
  Alert$1 as Alert,
  Skeleton$1 as Skeleton,
  Input$1 as Input,
  Textarea$1 as Textarea,
  FormField$1 as FormField,
  ArticleMeta$1 as ArticleMeta,
  IconButton$1 as IconButton,
  Chip$1 as Chip,
  Desk,
  make,
}
/* use Not a pure module */
